<div class="organisation-history-tab" data-testid="organisation-history-tab">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="alert alert-warning" role="alert" data-testid="organisation-history-error">{{ loadError }}</div>
    } @else if (entries.length === 0) {
        <p class="text-muted" data-testid="organisation-history-empty">No history yet</p>
    } @else {
        <div class="table-responsive">
            <table class="table table-sm align-middle" data-testid="organisation-history-table">
                <caption class="visually-hidden">History of this organisation</caption>
                <thead>
                    <tr>
                        <th scope="col">Action</th>
                        <th scope="col">Reason</th>
                        <th scope="col">Added on</th>
                    </tr>
                </thead>
                <tbody>
                    @for (entry of entries; track entry.id) {
                        <tr data-testid="organisation-history-row">
                            <td>{{ actionLabel(entry) }}</td>
                            <td class="organisation-history-reason">{{ entry.reason?.trim() ? entry.reason : 'N/A' }}</td>
                            <td>{{ entry.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (total > pageSize) {
            <ngb-pagination [collectionSize]="total" [pageSize]="pageSize" [page]="page"
                            (pageChange)="onPageChange($event)" [maxSize]="5" [boundaryLinks]="true"
                            aria-label="Organisation history pages" data-testid="organisation-history-pagination">
            </ngb-pagination>
        }
    }

    @if (canChangeState && (canDeactivate || canReactivate)) {
        @if (canDeactivate && blockedByServices) {
            <div class="alert alert-warning mt-3" role="status" id="organisation-deactivate-warning"
                 data-testid="organisation-deactivate-warning">
                <p class="mb-1">This organisation cannot be deactivated while it is linked to services.</p>
                <ul class="list-bulleted mb-0">
                    @for (service of linkedServices; track service.id) {
                        <li>{{ service.name }}</li>
                    }
                </ul>
            </div>
        }
        <div class="organisation-history-actions" [class.organisation-history-actions-end]="!canDeactivate">
            @if (canDeactivate) {
                <button type="button" class="btn btn-outline-danger" #stateButton
                        [disabled]="blockedByServices"
                        [attr.aria-describedby]="blockedByServices ? 'organisation-deactivate-warning' : null"
                        aria-haspopup="dialog"
                        (click)="openDeactivateModal()"
                        data-testid="organisation-deactivate">
                    <i class="bi bi-slash-circle me-2" aria-hidden="true"></i>Deactivate
                </button>
            } @else {
                <button type="button" class="btn btn-success" #stateButton
                        [disabled]="reactivating"
                        confirmHeader="Confirm the action"
                        confirmModal="Are you sure you want to reactivate this organisation?"
                        confirmMessage=""
                        confirmOk="Yes, proceed"
                        confirmCancel="No, cancel"
                        confirmOkClass="btn-success"
                        confirmCancelClass="btn-gray text-dark"
                        [confirmCancelFirst]="true"
                        (confirmedClick)="reactivate()"
                        data-testid="organisation-reactivate">
                    <i class="bi bi-arrow-counterclockwise me-2" aria-hidden="true"></i>Reactivate
                </button>
            }
        </div>
    }
</div>
